<template>
  <div class="ticket">
    <div class="content">
      <img id="ticketImg" src="https://qh45drthcniwym25yjgmdlc6nseaccs25h3tsdvljdjfovgl4e.arweave.net/gfnRxmcTUWwzXcJMwaxebIgBClrp9zkOq0j_SV1TL4Y" />

      <div id="descDiv">
        <span>
          A Gurupass which entitles a 20% discount for Mystic Gurus NFTs sold on OpenTheta. Just in time for the upcoming Core Set launch! Whichever wallet is purchasing Mystic Gurus NFTs on OpenTheta just needs to be in possession of the GuruPass NFT to receive discounts!
        </span>
      </div>

      <v-row id="mintPriceVRow">
        <v-col sm="5">
          <v-btn id="mintBtn" large @click="mint()" disabled>Mint</v-btn>
        </v-col>
        <v-col sm="7">
          <p id="priceP">Price:</p>
          <p id="valueP">12,000 Aura</p>
        </v-col>
      </v-row>

      <p id="purcahsedP">{{ guruCurrentMintedCnt }}/{{ guruMaxSupply }} sold out.</p>
    </div>
  </div>
</template>

<script>
  import Web3 from 'web3';

  const guruPassNFTAbi = require("../../constants/abis/guruPassNFT.json");

  export default {
    name: 'MaTicket',
    props: {
    },
    data: () => ({
      currentWalletAddress: "",
      guruPassContract: "",
      guruMaxSupply: 0,
      guruCurrentMintedCnt: 0,
      // WordPress bind data. eros god
      wpData: wpData,
    }),
    mounted() {
      this.initialize();
    },
    methods: {
      async initialize() {
        if (typeof window.ethereum === 'undefined') return;

        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        this.currentWalletAddress = accounts[0];

        const web3js = window.web3;
        if (typeof web3js === 'undefined') return;

        this.web3 = new Web3(web3js.currentProvider);

        this.web3.eth.defaultAccount = this.currentWalletAddress;

        this.guruPassContract = this.web3.eth.contract(guruPassNFTAbi).at(wpData.GURUPASS_NFT_CONTRACT_ADDRESS);

        this.updateStatistics();
      },
      mint() {
        this.guruPassContract.safeMint(this.currentWalletAddress, function(err) {
          if (err) { console.log(err.code); return; }

          location.reload();
        });
      },
      updateStatistics() {
        let _this = this;
        this.guruPassContract.MAX_NFT_SUPPLY.call(function(err, res) {
          if (err) { console.log(err.code); return; }

          _this.guruMaxSupply = res;
        });

        this.guruPassContract.totalSupply.call(function(err, res) {
          if (err) { console.log(err.code); return; }

          _this.guruCurrentMintedCnt = res;
        });
      }
    },
    computed: {
    },
  }
</script>

<style scoped>
  p {
    margin: 0px;
    font-family: Architects Daughter;
  }

  span {
    font-family: Architects Daughter;
  }

  .ticket {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    border-top-left-radius: 255px 15px;
    border-top-right-radius: 15px 225px;
    border-bottom-right-radius: 225px 15px;
    border-bottom-left-radius: 15px 255px;
    border: solid #881d84 18px;
    box-shadow: 20px 38px 34px -26px #626262;
    -webkit-transition: all .5s ease;
    transition: all .5s ease;
    background: #881d84;
  }
  .ticket .content {
    padding: 10px;
    background-color: #131313;
    border-radius: 29px 29px 29px 29px;
  }

  #ticketImg {
    border-top-left-radius: 29px;
    border-top-right-radius: 29px;
    width: 100%;
  }

  #descDiv {
    padding: 20px;
  }
  #descDiv span {
    color: white;
    text-align: center;
    font-size: 14px;
  }

  #mintPriceVRow {
    padding: 0px 20px;
  }
  #mintPriceVRow #mintBtn {
    background-color: #6EC1E4;
    margin-left: auto;
    margin-right: auto;
    text-transform: inherit;
    display: flex;
    font-family: Architects Daughter;
    font-size: 16px;
    color: white;
    font-weight: bold;
  }
  #mintPriceVRow #priceP {
    color: white;
    font-weight: bold;
  }
  #mintPriceVRow #valueP {
    color: yellow;
    font-weight: bold;
    font-size: 16px;
  }
  #purcahsedP {
    text-align: center;
    margin-bottom: 15px;
    color: white;
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MyAura/MaTicket.vue